import { Copy } from 'lucide-react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { components } from '@/types/strapi';
import { SingleColumnPopupProps } from './SingleColumnPopup';
interface SingleColumnDiscountOfferProps
	extends Omit<SingleColumnPopupProps, 'content'> {
	content: components['schemas']['PopupSingleColumnDiscountOfferComponent'];
}

export const SingleColumnDiscountOffer = ({
	content,
}: SingleColumnDiscountOfferProps) => {
	if (!content) {
		return null;
	}
	const handleCopyCode = () => {
		if (content.discountCode) {
			navigator.clipboard.writeText(content.discountCode);
		}
	};
	return (
		<div className="discount-offer">
			<div className="mt-6 pb-8">
				{content.discountCode && (
					<div className="mb-5 flex flex-col items-center">
						<div className="w-full rounded-md border border-gray-200 bg-gray-100 p-4 text-center">
							<span className="text-center font-mono text-xl font-bold tracking-wider">
								{content.discountCode}
								<button
									onClick={handleCopyCode}
									className="transform text-gray-400 hover:text-gray-600"
									title="Copy code">
									<Copy className="ml-2 h-5 w-5" />
								</button>
							</span>
						</div>
						<span className="mt-2 text-xs text-gray-500">
							{content.usage_message}
						</span>
					</div>
				)}
				<Link href={content?.button_?.URL || '/'}>
					<Button
						className="w-full py-6 text-base"
						variant="primary"
						size="lg">
						{content.button_?.text || 'Get Discount'}
					</Button>
				</Link>

				<div className="mt-4 flex justify-center">
					<button className="text-sm text-gray-500 hover:text-gray-700">
						{content.message}
					</button>
				</div>
			</div>
		</div>
	);
};
